module.exports = __webpack_public_path__ + "img/PL08808.20988698.png";